module.exports = __webpack_public_path__ + "static/media/rosette-header.62bbfa12.png";